import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';

export interface IKnowledgeBaseArticleDetails {
  id: number;
  symbol: string;
  section_id: number;
  title: string;
  is_active: boolean;
  from_date: string | null;
  to_date: string | null;
  layouts: string | null;
  show_in_sitemap: boolean | null;
  sys_insert_date: string;
  sys_update_date: string;
  article_fields: Record<string, string | null>;
}

const getKnowledgeBaseArticle = (slug: string | number): Promise<IKnowledgeBaseArticleDetails> =>
  axios.get(`/cms/knowledge-base/articles/${slug}`);

export const useGetKnowledgeBaseArticle = (
  slug: string | number,
  options?: UseQueryOptions<IKnowledgeBaseArticleDetails, IError>
) =>
  useQuery<IKnowledgeBaseArticleDetails, IError>(
    ['knowledge-base-article', slug],
    () => getKnowledgeBaseArticle(slug),
    { enabled: !!slug && slug !== 0, ...options }
  );
